class FostrAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.speed = this.dataset.speed * 1000 || 4000;
    this.slidesContainer = this.querySelector(
      ".fostr-announcement-bar__slides"
    );
    //this.slidesContainer.addEventListener('mouseenter', this.pauseSlide.bind(this));
    //this.slidesContainer.addEventListener('mouseleave', this.resumeSlide.bind(this));


     const sectionObserver = new IntersectionObserver(

        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              document.body.classList.add("announcement-bar--in-view");
            } else {
              document.body.classList.remove("announcement-bar--in-view");
            }
          });
        },
        {
          rootMargin: "0px 0px -50% 0px",
        }
      );

      // 👇 controllo: esiste almeno una slide?
      const hasSlides = this.querySelector(".fostr-announcement-bar__slide");

      if (hasSlides) {
        sectionObserver.observe(this);
    }


    const duplicateSlidesEl = document.createElement("div");
    duplicateSlidesEl.innerHTML = this.slidesContainer.innerHTML;
    duplicateSlidesEl.innerHTML += this.slidesContainer.innerHTML;

    const duplicateSlides = duplicateSlidesEl.querySelectorAll("li");
    const duplicateSlidesDivs = duplicateSlidesEl.querySelectorAll("li div");
    duplicateSlidesDivs.forEach((slide, index) => {
      slide.setAttribute("id", `fostr-announcement-bar__slide-${index}`);
      slide.setAttribute(
        "aria-label",
        `Slide ${index + 1} of ${duplicateSlidesDivs.length}`
      );
    });

    this.slidesContainer.innerHTML = "";
    duplicateSlides.forEach((slide) => {
      this.slidesContainer.appendChild(slide);
    });

    this.slides = this.querySelectorAll(".fostr-announcement-bar__slide");
    this.allInteractiveElements = this.slidesContainer.querySelectorAll(
      ".fostr-announcement-bar__slide a"
    );
    this.totalSlides = this.slides.length;

    // Set container's initial aria-label
    //this.updateContainerAriaLabel(1);

    this.currentIndex = 0;
    this.slideInterval = null;
    this.isPaused = false;

    this.slideInterval = setInterval(() => {
      this.slideNext();
    }, this.speed);

    this.toggleButton = this.querySelector(".announcement-bar__toggle_button");
    this.toggleButton.addEventListener("click", this.toggleSlide.bind(this));
  }

  disconnectedCallback() {
    clearInterval(this.slideInterval);
  }
  /*
  updateContainerAriaLabel(currentSlideNumber) {
    // Use half the total slides since we duplicated them
    const actualTotalSlides = this.totalSlides / 2;
    this.slidesContainer.setAttribute('aria-label', `slide ${currentSlideNumber} of ${actualTotalSlides}`);
  }
  */

  slideNext() {
    if (this.currentIndex === this.totalSlides - 1) {
      this.currentIndex = 0;
    } else {
      this.currentIndex++;
    }
    this.hideNonVisibleSlides();
    // Update aria-label with the current slide number (accounting for duplicated slides)
    const currentSlideNumber = (this.currentIndex % (this.totalSlides / 2)) + 1;
    //this.updateContainerAriaLabel(currentSlideNumber);

    if (this.currentIndex > this.totalSlides / 2) {
      this.currentIndex = 0;
      clearInterval(this.slideInterval);
      this.slidesContainer.style.scrollBehavior = "instant !important";
      this.slidesContainer.scrollLeft =
        this.slides[this.currentIndex].offsetLeft;
      this.slidesContainer.style.scrollBehavior = "";
      this.slideInterval = setInterval(() => {
        this.slideNext();
      }, this.speed);
    } else {
      this.slidesContainer.scroll({
        left: this.slides[this.currentIndex].offsetLeft,
        behavior: "smooth",
      });
    }
    this.showVisibleSlide();
  }

  pauseSlide() {
    clearInterval(this.slideInterval);
    this.isPaused = true;
    this.toggleButton.querySelector(".icon-pause").classList.add("hidden");
    this.toggleButton.querySelector(".icon-play").classList.remove("hidden");
  }

  resumeSlide() {
    if (this.isPaused) {
      this.slideInterval = setInterval(() => {
        this.slideNext();
      }, this.speed);
      this.isPaused = false;
      this.toggleButton.querySelector(".icon-pause").classList.remove("hidden");
      this.toggleButton.querySelector(".icon-play").classList.add("hidden");
    }
  }

  toggleSlide() {
    if (this.isPaused) {
      this.resumeSlide();
    } else {
      this.pauseSlide();
    }
  }

  hideNonVisibleSlides() {
    // Hide all slides from screen reader and keyboard users
    this.slides.forEach((slide, index) => {
      if (index !== this.currentIndex) {
        slide.setAttribute("aria-hidden", true);
      }
    });

    // Make sure that no interactive elements of any slide is focusable
    this.allInteractiveElements.forEach((element) => {
      element.setAttribute("tabindex", -1);
    });
  }
  showVisibleSlide() {
    this.slides.forEach((slide, index) => {
      if (index == this.currentIndex) {
        slide.removeAttribute("aria-hidden");
      }
    });

    // Make sure all interactive elements of the active slide are focusable
    const activeSlideInteractiveElements =
      this.slides[this.currentIndex].querySelectorAll("a");

    activeSlideInteractiveElements.forEach((element) => {
      element.removeAttribute("tabindex");
    });
  }
}

customElements.define("fostr-announcement-bar", FostrAnnouncementBar);
